export default __webpack_public_path__ + "static/media/gw200-7.85ff5687.png";